module.exports = __webpack_public_path__ + "img/search-hero-overflow-kia.74ab203d.png";